import { PageMeta } from "@/components/common/PageMeta";
import { ChatLayout } from "@/components/chat/ChatLayout";

export function FundComplianceAgentPage() {
  return (
    <div className="flex flex-col pt-[var(--topnav-height)] h-dvh">
      <PageMeta
        title="Fund Compliance Agent | COSX"
        description="AI-powered fund compliance assistant."
        path="/demo/fund-compliance-agent"
        noindex
      />
      <ChatLayout />
    </div>
  );
}
